import type { KeldaPathOps } from '@mimir/client-common/fileSync/keldaPathOps';
import type { KeldaPathMapping } from '@mimir/client-common/fileSync/premiereTypes';
import type { ItemWithSourceMedia } from '@mimir/client-common/upload/premiereItemTypes';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { ItemArtefact } from '@mimir/common/dto/transferRequestDtos';
import type { ArtifactReference } from '@mimir/primitive/artifactReference';
import type { Logger } from '@mimir/common/types/logger';
import type { NodeApi } from '@mimir/common/util/detectApi';
import { getLocalKeldaMappedPath } from '@mimir/client-common/upload/getLocalKeldaMappedPath';

export class DefaultKeldaPathOps implements KeldaPathOps {

  constructor(
    private applicationContext: AdobePanelContext | ElectronContext,
    private logger: Logger,
    private keldaPathMappings: KeldaPathMapping[],
  ) {}


  async getLocalKeldaMappedPath(
    item: ItemWithSourceMedia,
    artefact: ItemArtefact,
    artifactReference: ArtifactReference,
    isFileAvailableLocallyInjected: (nodeApi: NodeApi, logger: Logger, localPath: string | null | undefined) => Promise<boolean>,
  ): Promise<string | undefined> {
    const services = {
      applicationContext: this.applicationContext,
      logger: this.logger,
    };
    return await getLocalKeldaMappedPath(services, this.keldaPathMappings, item, artefact, artifactReference, isFileAvailableLocallyInjected);
  }

}
